// ============================================================================
// REGION ENDPOINTS
// ============================================================================
// BASE_PATH MUST match the backend controller's [controller] route token.
// RegionController -> api/v1/Region -> BASE_PATH = '/Region' (singular, case-sensitive).

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const REGION_BASE_PATH = '/Region';

export const regionEndpoints = {
  list: () => buildEndpoint(REGION_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${REGION_BASE_PATH}/:id`, { id }),
  getByCode: (code: string) => buildEndpointWithParams(`${REGION_BASE_PATH}/code/:code`, { code }),
  create: () => buildEndpoint(REGION_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${REGION_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${REGION_BASE_PATH}/:id`, { id }),
  validateCode: (code: string) => buildEndpointWithParams(`${REGION_BASE_PATH}/validate/code/:code`, { code }),
} as const;

export default regionEndpoints;
